import React, { useState } from 'react';
import { API } from '../utils/helpers';
import SpinboardMark from './SpinboardMark';

const colors = {
  bg: '#0f1623',
  card: '#1a2336',
  border: '#243050',
  text: '#e8e4dc',
  muted: '#5a6a8a',
  accent: '#F4622A',
  input: '#111827',
};

export default function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showForgot, setShowForgot] = useState(false);
  const [forgotEmail, setForgotEmail] = useState('');
  const [forgotSent, setForgotSent] = useState(false);

  async function handleLogin(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch(`${API}/auth/users/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error || 'Login failed'); return; }
      localStorage.setItem('sb_token', data.token);
      localStorage.setItem('sb_user', JSON.stringify(data.user));
      onLogin(data.user);
    } catch (err) {
      setError('Connection error � please try again');
    } finally {
      setLoading(false);
    }
  }

  async function handleForgot(e) {
    e.preventDefault();
    setLoading(true);
    try {
      await fetch(`${API}/auth/users/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: forgotEmail }),
      });
      setForgotSent(true);
    } catch (_) {
      setForgotSent(true);
    } finally {
      setLoading(false);
    }
  }

  const inputStyle = {
    width: '100%', padding: '10px 12px', borderRadius: 6,
    border: `1px solid ${colors.border}`,
    background: colors.input,
    color: colors.text,
    fontSize: 14, boxSizing: 'border-box',
    outline: 'none',
  };

  const btnStyle = {
    width: '100%', padding: '11px', borderRadius: 6, border: 'none',
    background: colors.accent, color: '#fff', fontSize: 15,
    fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer',
    opacity: loading ? 0.7 : 1, marginTop: 4,
  };

  const labelStyle = {
    fontSize: 11, color: colors.muted, display: 'block',
    marginBottom: 6, letterSpacing: '0.06em', fontWeight: 600,
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', background: colors.bg,
      fontFamily: 'Arial, sans-serif',
    }}>
      <div style={{
        width: 360, background: colors.card, borderRadius: 12,
        padding: '40px 36px', boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
        border: `1px solid ${colors.border}`,
      }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
	  <div style={{
	    width: 56, height: 56, background: '#243050', borderRadius: 12,
	    display: 'flex', alignItems: 'center', justifyContent: 'center',
	    margin: '0 auto 12px',
	  }}>
	    <SpinboardMark size={36} />
	  </div>
	  <div style={{ fontSize: 22, fontWeight: 800, color: colors.accent, letterSpacing: '-0.5px', marginBottom: 4 }}>
	    spinboard.
	  </div>
	  <div style={{ fontSize: 12, color: colors.muted }}>
	    Service Intelligence for Bike Shops
	  </div>
</div>

        {!showForgot ? (
          <>
            <form onSubmit={handleLogin}>
              <div style={{ marginBottom: 18 }}>
                <label style={labelStyle}>USERNAME</label>
                <input
                  style={inputStyle}
                  value={username}
                  onChange={e => setUsername(e.target.value)}
                  autoComplete="username"
                  autoFocus
                />
              </div>
              <div style={{ marginBottom: 22 }}>
                <label style={labelStyle}>PASSWORD</label>
                <input
                  type="password"
                  style={inputStyle}
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  autoComplete="current-password"
                />
              </div>
              {error && (
                <div style={{
                  color: '#e74c3c', fontSize: 13, marginBottom: 14,
                  textAlign: 'center', background: 'rgba(231,76,60,0.1)',
                  padding: '8px 12px', borderRadius: 6,
                }}>
                  {error}
                </div>
              )}
              <button type="submit" style={btnStyle} disabled={loading}>
                {loading ? 'Signing in...' : 'Sign In'}
              </button>
            </form>
            <div style={{ textAlign: 'center', marginTop: 18 }}>
              <button
                onClick={() => setShowForgot(true)}
                style={{
                  background: 'none', border: 'none',
                  color: colors.muted, cursor: 'pointer', fontSize: 13,
                }}
              >
                Forgot password?
              </button>
            </div>
          </>
        ) : (
          <>
            {!forgotSent ? (
              <form onSubmit={handleForgot}>
                <div style={{ fontSize: 14, color: colors.text, marginBottom: 20, lineHeight: 1.5 }}>
                  Enter your email address and we'll send you a reset link.
                </div>
                <div style={{ marginBottom: 20 }}>
                  <label style={labelStyle}>EMAIL</label>
                  <input
                    type="email"
                    style={inputStyle}
                    value={forgotEmail}
                    onChange={e => setForgotEmail(e.target.value)}
                    autoFocus
                  />
                </div>
                <button type="submit" style={btnStyle} disabled={loading}>
                  {loading ? 'Sending...' : 'Send Reset Link'}
                </button>
                <div style={{ textAlign: 'center', marginTop: 16 }}>
                  <button
                    onClick={() => setShowForgot(false)}
                    style={{
                      background: 'none', border: 'none',
                      color: colors.muted, cursor: 'pointer', fontSize: 13,
                    }}
                  >
                    Back to sign in
                  </button>
                </div>
              </form>
            ) : (
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontSize: 40, marginBottom: 12, color: colors.accent, fontWeight: 700 }}>@</div>
                <div style={{ fontSize: 15, color: colors.text, marginBottom: 8, fontWeight: 600 }}>
                  Check your email
                </div>
                <div style={{ fontSize: 13, color: colors.muted, marginBottom: 24, lineHeight: 1.5 }}>
                  If an account exists for that email, a reset link has been sent.
                </div>
                <button
                  onClick={() => { setShowForgot(false); setForgotSent(false); setForgotEmail(''); }}
                  style={{
                    background: 'none', border: 'none',
                    color: colors.accent, cursor: 'pointer', fontSize: 13,
                  }}
                >
                  Back to sign in
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}